// Calls to the server
const BASE_URL = `https://comaconltd.com/comacon/public/api`;

export const sendMails = `${BASE_URL}/send-mail`;
